import { useFormContext } from 'react-hook-form';

import { PunchupLineItemList } from 'features/common/components/Punchup/primitives/display/PunchupLineItemList';

import { RecipientInfoProps } from './types';
import styles from './PunchupRecipientInfo.module.css';

export const PunchupRecipientInfo = ({ ticketTypes: ticketTypesProp, recipientId }: RecipientInfoProps) => {
	const { watch } = useFormContext();
	const email = watch(`recipients[${recipientId}].email`);
	const firstName = watch(`recipients[${recipientId}].firstName`);
	const lastName = watch(`recipients[${recipientId}].lastName`);
	// For a no-email comp the email is blank/placeholder, so fall back to the recipient's name — otherwise
	// the confirmation shows a bare "To:" with no one named.
	const recipientLabel = email || [firstName, lastName].filter(Boolean).join(' ').trim();
	const day = watch('day.label');
	const time = watch('time.label');
	// Watch ticket types directly so re-renders are triggered when the seated form
	// updates them via setValue — falls back to the prop value when the form path is empty.
	const watchedTicketTypes = watch(`recipients[${recipientId}].ticketTypes`);
	const ticketTypes = (
		Array.isArray(watchedTicketTypes) && watchedTicketTypes.length > 0 ? watchedTicketTypes : ticketTypesProp
	) as RecipientInfoProps['ticketTypes'];
	return (
		<div className={styles.recipientInfo}>
			<p className={styles.email}>To:{recipientLabel ? ` ${recipientLabel}` : ''}</p>
			{day && time && (
				<p className={styles.dateTime}>
					<strong>{day}</strong> {time}
				</p>
			)}
			<PunchupLineItemList
				items={ticketTypes.map(({ type, initialPrice, quantity }) => ({
					label: type,
					count: quantity,
					price: initialPrice * quantity,
				}))}
			/>
		</div>
	);
};
